import React, { useState, Fragment,useEffect } from "react";
import {accountService} from "./Account.service";
import axios from "axios";
import {useParams} from "react-router-dom";
import {Form} from "react-bootstrap";

accountService.isLoggedRedirect();

function App() {

    let {id} = useParams();
    const mytoken = JSON.parse(localStorage.getItem('token')).token;
    const config = {headers: {Authorization: `Bearer ${mytoken}`}};
    const [careerdatas, setCareerDatas] = useState({});
    const [datacareer, setDataCareer] = useState([]);
    const [Career, setCareer] = useState({});
    const [dateStart, setDateStart] = useState({});
    const [dateEnd, setDateEnd] = useState({});

    useEffect(() => {
        axios.get(`https://api.nvdxavier.com/api/career/` + id, config)
            .then(data => {
                setCareerDatas(data.data);
                const date = new Date(data.data.datestart);
                let dateStartMDY = `${date.getUTCDay()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                setDateStart({datestartexp: dateStartMDY})
                let dateEndMDY = `${date.getUTCDay()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                setDateEnd({dateendexp: dateEndMDY})
                setCareer(
                    {
                        id: data.data.id,
                        jobtitle: data.data.jobtitle,
                        societyaddress: data.data.societyaddress,
                        link: data.data.link,
                        society: data.data.society,
                        taskdescription: data.data.taskdescription,
                        datestart: data.data.datestart,
                        dateend: data.data.dateend,
                        inplace: data.data.inplace
                    }
                )
            }).catch(err => console.error(err));
    }, [config, id]);
    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(name === 'dateend' || name === 'datestart'){
            setCareer({...Career, [name]: value+'T15:52:01+00:00'});
        }else{
            setCareer({...Career, [name]: value});
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const updateCareer = { ...Career}
        setDataCareer([...datacareer, updateCareer]);
        const dataEncodedtoJson = JSON.stringify(updateCareer);
        axios.put(`https://api.nvdxavier.com/api/career/`+id, dataEncodedtoJson, config)
            .then(data => data.status === 204 ? window.location.replace("/admin/careers/") : console.log(data.status))
            .catch(err => console.error(err));
    };

    return (
        <Fragment>
            <section id="signup" className="signup-section">
                <div className="container" key="CurriculumAdmin">
                    <div className="align-self-center" key="CareerAdminAlign">
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3 col-4" controlId="formBasicEmail">
                                <Form.Label>Title</Form.Label>
                                <Form.Control type="text" placeholder={careerdatas.jobtitle} name="jobtitle" value={Career.jobtitle} onChange={handleChange}/>
                                <Form.Label>Date start  : {dateStart.datestartexp}</Form.Label>
                                <Form.Control size="sm" type="date" placeholder={careerdatas.datestart} name="datestart" onChange={handleChange}/>
                                <Form.Label>Date end  : {dateEnd.dateendexp}</Form.Label>
                                <Form.Control size="sm" type="date" placeholder={careerdatas.dateend} name="dateend" onChange={handleChange}/>
                                <Form.Label>Task description</Form.Label>
                                <Form.Control size="sm" as="textarea" placeholder={careerdatas.taskdescription} name="taskdescription" value={Career.taskdescription} onChange={handleChange}/>
                                <Form.Label>Society</Form.Label>
                                <Form.Control type="text" placeholder={careerdatas.society} name="society" value={Career.society} onChange={handleChange}/>
                                <Form.Label>Society address</Form.Label>
                                <Form.Control type="text" placeholder={careerdatas.societyaddress} name="societyaddress" value={Career.societyaddress} onChange={handleChange}/>
                                <Form.Label>Society website</Form.Label>
                                <Form.Control type="link" placeholder={careerdatas.link} name="link" value={Career.link} onChange={handleChange}/>
                                <Form.Label>My actual job ?</Form.Label>
                                <Form.Check type="checkbox" id={`disabled-default`} name="inplace" defaultChecked={careerdatas.inplace} onChange={handleChange}/>
                                <input type="submit" value="Submit" className="btn btn-danger"/>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            </section>
        </Fragment>
    )
}
export default App;